import {NotePriority} from "./NotePriority";

export class BluechatNoteAttachment {
  filename: string;
  data: string;
  mime_type: string;
}

export class BluechatNoteCreation {
  message: string;
  topic: string;
  company_code: string;
  domain: string;
  category: string;
  delivery_number: string;
  priority: NotePriority;
}
